import { CaregiverDailyBehaviorLogPageContent } from "../../caregiver/pages/CaregiverDailyBehaviorLogPage";

const SharedResidentDailyBehaviorLogPage = () => (
  <CaregiverDailyBehaviorLogPageContent sharedMode />
);

export default SharedResidentDailyBehaviorLogPage;
